import './DownloadEMLModal.scss';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface DownloadEMLModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const DownloadEMLModal: React.FC<DownloadEMLModalProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="download-eml-dialog"
      PaperProps={{
        elevation: 0,
      }}>
      <Box sx={{ position: 'absolute', right: 16, top: 16 }}>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: '#7c7c7c', fontSize: 20 }} />
        </IconButton>
      </Box>

      <DialogContent className="dialog-content">
        <Box className="icon-container">
          <AccessTimeIcon className="clock-icon" />
          <Box className="download-badge">
            <GetAppIcon className="download-icon" />
          </Box>
        </Box>

        <Typography className="title">
          Review and Send the Downloaded Email
        </Typography>

        <Typography className="subtitle">
          Once the email has been downloaded, please open the file, review the
          details, and send it to the client associated with this record. Ensure
          all attachments and content are accurate before sending.
        </Typography>

        <Button
          className="mark-submitted-btn"
          variant="contained"
          onClick={onConfirm}
          disabled={isSubmitting}>
          {isSubmitting ? 'Processing...' : 'Mark As Submitted'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadEMLModal;
